/**
 * Team module pagination constants
 */
export const TEAM_DROPDOWN_PAGE_SIZE = 25;
